import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const FacetContainer = styled.div`
    padding: ${getPurpurSpacing('300')};
`;

export const DrawerOpenButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${getPurpurBorder('radiusSm')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractiveSubtle')};
    background-color: ${getPurpurColor('functionalWhite')};
    gap: ${getPurpurSpacing('100')};
    padding: 0 ${getPurpurSpacing('200')};
    width: 100%;
    height: 2.75rem;

    &:hover {
        border-color: ${getPurpurColor('borderInteractivePrimaryHover')};
    }

    &:active {
        border-color: ${getPurpurColor('borderInteractivePrimaryActive')};
    }

    ${purpurFocus()};
`;

export const DrawerOpenButtonName = styled.span`
    font-weight: ${getPurpurTypography('weightMedium')};
    color: ${getPurpurColor('purple900')};
`;
